
import React,{ Component } from 'react';
import Resumen from './ItemsDetalle/Resumen';
import TabFacturacion from './ItemsDetalle/Facturacion';
import TabAdicionales from './ItemsDetalle/Adicionales';
import UsoYcolor from './ItemsDetalle/UsoYcolor';
import Historial from './ItemsDetalle/Historial';
import Inmatriculacion from './ItemsDetalle/Inmatriculacion';
import getPedidosPedidosAutorizaciones from '../../../utils/getPedidosPedidosAutorizaciones';
import getPedidosPedidos from '../../../utils/getPedidosPedidos';
import getHistorialMovPedidos from '../../../utils/getHistorialMovPedidos';
import { FadeLoader } from 'react-spinners';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { CLEAR_SITUACIONES } from '../../../actions';
import SituacionComponent from './ItemsDetalle/SituacionComponent';
import EntregaComponent from './ItemsDetalle/EntregaComponent';

class PedidoDetalle extends Component {

    constructor(props){
      super(props);
      this.state= {
        ValueTab:1,
        rowSelected:'',
        idModal:'Pedido',
        pedidosAutorizaciones:[],
        pedidos:{},
        historialPedidos:[],
        muestraLoad:''
      };
    }

    loading = (status) =>{
       this.setState({ muestraLoad: status });
     }

    componentDidMount() {
        if(this.props.pedidos.numFichaVtaVeh!==undefined){
          this.fnGetPedidosPedidosAutorizaciones();
        }

    }


    fnGetPedidosPedidosAutorizaciones = () => {

      this.loading('block')
      let {numFichaVtaVeh,numProfVeh,codCia,codProv,numPedidoVeh} = this.props.pedidos;
      getPedidosPedidosAutorizaciones(numFichaVtaVeh, numProfVeh, codCia, codProv, numPedidoVeh,'P').then((result) => {

            let autorizaciones = result.data.actividadesList;
            if (_.isArray(autorizaciones)) {
              autorizaciones = _.sortBy(autorizaciones, ['numOrdenHito','numOrdenAct']);
              autorizaciones = _.groupBy(autorizaciones, 'codHitoFive');
              autorizaciones = _.toArray(autorizaciones);
            }
            this.loading('')
            this.loadPedidos();
            this.setState({ pedidosAutorizaciones: autorizaciones});

          }).catch(error => console.log(error));

    }

    toggleRow = (index) => {
      if (index === this.state.rowSelected) {
        this.setState({ rowSelected: '' });
      } else {
        this.setState({ rowSelected: index });
      }
    }

    loadPedidos = () => {
              getPedidosPedidos(this.props.pedidos.numFichaVtaVeh, [this.props.pedidos.numProfVeh]).then((result) => {

                    let pedido =  _.filter(result, _.property(this.props.pedidos.numProfVeh))[0][this.props.pedidos.numProfVeh];
                    pedido = pedido.find(entry => entry.numPedidoVeh===this.props.pedidos.numPedidoVeh);

                    this.setState({  pedidos:  pedido});
                  })
                  .catch((error) => { console.log(error); });
    }

    cheCkTab = (option) =>  this.setState({ValueTab:option});

    render(){
        return (
          this.state.pedidos !== undefined? (
          <div className={`modal ${this.props.isOpen ? 'js-open' : ''}`} id={this.state.idModal} role='dialog' data-backdrop='static'>
            <div className='modal-dialog modal-lg modal-noTitle' role='document'>
              <button className='btn btn-sm btn-blue modal-close' data-dismiss='modal' onClick={() => this.props.closeModal()} >Cerrar ventana</button>
              <div className='modal-content'>
                <div className='modal-body'>
                  <div className='modalBleed modalBleed-top'>
                    <div className='carCard'>
                      <div className='carCard-firstInfo'>
                        {/*<div className='fdv-validateList'>
                          <p className='labelInfo'>Validado por:</p>
                          <ul>
                            <li className='btn-iconLeft'><i className='ion-checkmark-circled c-green' />Cliente</li>
                            <li className='btn-iconLeft c-gray'><i className='ion-minus-circled' />Facturación</li>
                          </ul>
                        </div>
                        <div className='text-right'>
                          <div className='dropdown kebab' role='group'>
                            <button className='btn dropdown-toggle kebab-btn' data-toggle='dropdown' aria-haspopup='true' aria-expanded='false'><i className='ion-android-more-vertical' /></button>
                            <ul className='dropdown-menu dropdown-menu-right'>
                              <li><a className='pageHead-tableActionItem' data-toggle='modal' data-target='#fdv-desasignarPedido'><i className='ion-loop' /><span>Desasignar pedido</span></a></li>
                              <li><a className='pageHead-tableActionItem'><i className='ion-android-mail' /><span>Compartir por email</span></a></li>
                              <li><a className='pageHead-tableActionItem'><i className='ion-android-print' /><span>Imprimir</span></a></li>
                              <li><a className='pageHead-tableActionItem'><i className='ion-android-download' /><span>Resumen FDV</span></a></li>
                            </ul>
                          </div>
                        </div>*/}
                        <div className='div'>
                          <p className='tag tag-Top tag-yellow'>Pendiente</p>
                        </div>
                        <ul className='carCard-mainInfo row'>
                          <li className='carCard-status-item col-md-8'>
                            <div className='carCard-mainInfo-head'>
                              <button className='btn btn-iconLeft btn-link mt--4' data-dismiss='modal' data-toggle='modal' data-target='#fdv-detalle'  onClick={() => this.props.closeModal()} ><span></span></button>
                              <h2 className='carCard-title'>Pedido {this.state.pedidos.numPedidoVeh}</h2>
                              <h4 className='carCard-subTitle'>{this.state.pedidos.desCliente}</h4>
                            </div>
                          </li>
                          <li className='carCard-status-item col-md-2'>
                            <div className='carCard-mainInfo-chasis'>
                              <p className='labelInfo'>Nº FDV</p>
                              <p>{this.state.pedidos.numFichaVtaVeh}</p>
                            </div>
                          </li>
                          <li className='carCard-status-item col-md-2'>
                            <div className='carCard-mainInfo-chasis'>
                              <p className='labelInfo'>{this.state.pedidos.estadoPedido}</p>
                              <p>{this.state.pedidos.fechPreasignado}</p>
                            </div>
                          </li>
                        </ul>
                      </div>
                      <div className='carCard-sec'>
                        <div className='row'>
                          <div className='col-sm-2'>
                            <p className='labelInfo'>N° Chasis</p>
                            <p>{this.state.pedidos.numChasis}</p>
                          </div>
                          <div className='col-sm-2'>
                            <p className='labelInfo'>SKU</p>
                            <p>{this.state.pedidos.sku}</p>
                          </div>
                          <div className='col-sm-2'>
                            <p className='labelInfo'>Motor</p>
                            <p>{this.state.pedidos.numMotorVeh}</p>
                          </div>
                          <div className='col-sm-2'>
                            <p className='labelInfo'>Año</p>
                            <p>{this.state.pedidos.anoFabricacionVeh}</p>
                          </div>
                          <div className='col-sm-2'>
                            <p className='labelInfo'>Situación</p>
                            <p>{this.state.pedidos.desSituPedido}</p>
                          </div>
                          <div className='col-sm-2'>
                            <p className='labelInfo'>Ubicación</p>
                            <p>{this.state.pedidos.desUbicaPedidoVeh}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='tabs-hr'>
                      <div className='tabs-container'>
                        <button className='tabs-left'><i className='ion-chevron-left' /></button>
                        <div className='tabs-wrapper'>
                          <ul className='tabs' role='tablist'>
                            <li className={`tabs-item ${this.state.ValueTab === 1 ?'active':''}`} role='presentation'><a className='tabs-item-link'  data-toggle='tab' onClick={()=> this.cheCkTab(1)} >Resumen</a></li>
                            <li className={`tabs-item ${this.state.ValueTab === 2 ?'active':''}`} role='presentation'><a className='tabs-item-link'  data-toggle='tab'  onClick={()=> this.cheCkTab(2)}>Facturación</a></li>
                            <li className={`tabs-item ${this.state.ValueTab === 3 ?'active':''}`} role='presentation'><a className='tabs-item-link'  data-toggle='tab'  onClick={()=> this.cheCkTab(3)}>Color y uso</a></li>
                            <li className={`tabs-item ${this.state.ValueTab === 4 ?'active':''}`} role='presentation'><a className='tabs-item-link'  data-toggle='tab'  onClick={()=> this.cheCkTab(4)}>Adicionales</a></li>
                            <li className={`tabs-item ${this.state.ValueTab === 6 ?'active':''}`} role='presentation'><a className='tabs-item-link'  data-toggle='tab'  onClick={()=> this.cheCkTab(6)}>Inmatriculación</a></li>
							{/*REQ-86365*/
                            <li className={`tabs-item ${this.state.ValueTab === 7 ?'active':''}`} role='presentation'><a className='tabs-item-link'  data-toggle='tab'  onClick={()=> this.cheCkTab(7)}>Situaci&oacute;n</a></li>
                            /*REQ-86365*/
                            }
                            {
                              <li className={`tabs-item ${this.state.ValueTab === 8 ?'active':''}`} role='presentation'><a className='tabs-item-link'  data-toggle='tab'  onClick={()=> this.cheCkTab(8)}>Entrega</a></li>
                            }
                          </ul>
                        </div>
                        <button className='tabs-right'><i className='ion-chevron-right' /></button>
                      </div>
                    </div>
                  </div>
                  <div className='tab-content'>

                    {
                      this.state.ValueTab === 1 &&
                      <Resumen
                        pedidosAutorizaciones={this.state.pedidosAutorizaciones}
                        loading ={this.loading}
                      />
                    }
                    {
                      this.state.ValueTab === 2 &&
                      <TabFacturacion
                      solicitudfacturacion={this.props.solicitudfacturacion }
                      selectPedido = {this.state.pedidos.numPedidoVeh}
                      rowSelected= {this.state.rowSelected}
                      toggleRow = {this.toggleRow}
                      fdvID ={this.state.pedidos.numFichaVtaVeh}
                      selectProforma = {this.state.pedidos.numProfVeh}
                      loading ={this.loading}
                      pedido = {this.props.pedidos}
                      />
                    }

                    {
                      this.state.ValueTab === 3 &&
                      <UsoYcolor
                      fdvID ={this.state.pedidos.numFichaVtaVeh}
                      selectPedido = {this.state.pedidos.numPedidoVeh}
                      selectNurPedido = {this.state.pedidos.nurFichaVtaPedido}
                      loading ={this.loading}
                      />
                    }

                    {
                     this.state.ValueTab === 4 &&
                      <TabAdicionales
                        fdvID ={this.state.pedidos.numFichaVtaVeh}
                        selectPedido = {this.state.pedidos.numPedidoVeh}
                        selectProforma = {this.state.pedidos.numProfVeh}
                        loading ={this.loading}

                      />
                    }

                    {
                     this.state.ValueTab === 5 &&
                      <Historial
                        pedido = {this.props.pedidos}
                        loading ={this.loading}
                      />
                    }

                    {
                     this.state.ValueTab === 6 &&
                      <Inmatriculacion
                        fdvID ={this.state.pedidos.numFichaVtaVeh}
                        selectPedido = {this.state.pedidos.numPedidoVeh}
                        loading ={this.loading}
                      />
                    }
					         {
                      /*REQ-86365*/
                      this.state.ValueTab === 7 &&
                      <SituacionComponent
                      numFichaVta = {this.state.pedidos.numFichaVtaVeh}
                      numPedidoVeh = {this.state.pedidos.numPedidoVeh}
                      codCia = {this.state.pedidos.codCia}
                      codProv = {this.state.pedidos.codProv}
                      loading ={this.loading}
                      />
                      /*REQ-86365*/
                    }
                    
                    {
                     this.state.ValueTab === 8 &&
                      <EntregaComponent
                      numPedidoVeh = {this.props.pedidos.numPedidoVeh}
                      loading ={this.loading}
                      />
                    }
                    
                    <div className='modal extraFilter' role='dialog' data-backdrop='static' style={{ display: this.state.muestraLoad }} >
                      <div className='modal-dialog modal-sm' role='document'>
                        <FadeLoader color={'#F8A14A'} loading />
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
          ):null
        )


    }

};



PedidoDetalle.defaultProps = {
  proformas: [],
  pedidos: [],
};

function mapStateToProps(state) {
  return {
    facturacion:state.facturacion
  }
}

export default withRouter(
connect(mapStateToProps, {
})(PedidoDetalle));



// WEBPACK FOOTER //
// ./src/pages/DetalleFichaVenta/DetallePedido/PedidoDetalle.js